import React from "react";

import classNames from "classnames";
import { Form } from "react-bootstrap";

import { useUmpiresContext } from "../../../contexts/Umpires";

const SearchBox = (): React.JSX.Element => {
    const { searchValue, setSearchValue } = useUmpiresContext();
    return (
        <Form.Control
            type="text"
            name="search"
            style={{ width: "200px", marginLeft: "auto" }}
            className={classNames("mauto")}
            placeholder="Search Value..."
            value={searchValue}
            onChange={e => setSearchValue(e.target.value)}
        />
    );
};

export default SearchBox;
